import { render, staticRenderFns } from "./flaggedKeyword.vue?vue&type=template&id=7257cd17&scoped=true"
import script from "./flaggedKeyword.vue?vue&type=script&lang=js"
export * from "./flaggedKeyword.vue?vue&type=script&lang=js"
import style0 from "./flaggedKeyword.vue?vue&type=style&index=0&id=7257cd17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7257cd17",
  null
  
)

export default component.exports